import type { PayloadAction } from '@reduxjs/toolkit';
import type { InitialLookUpStateType } from 'src/redux/look-up/types';

const reducers = {
  updateLookupData: (
    state: InitialLookUpStateType,
    action: PayloadAction<{ [key: string]: any }>,
  ) => {
    state.lookupData = { ...(state?.lookupData || {}), ...(action.payload || {}) };
  },
  marketsLookUpStarted: (state: InitialLookUpStateType) => {
    state.hasMarketsLookUpError = false;
  },
  marketsLookUpFailed: (state: InitialLookUpStateType) => {
    state.hasMarketsLookUpError = true;
  },
};

export default reducers;
